<template>
  <o-dialog
    ref="dialog"
    :title="$t('general.unsavedChanges')"
    :info="$t('components.reservation.actions.unsavedChanged.info')"
    :portal="portal"
    :options="[
      { text: $t('general.cancel'), type: 'cancel'},
      { text: $t('general.save'), type: 'confirm', response: 'save', callback: confirm }
    ]"
  />
</template>

<script setup lang="ts">
interface Props {
  portal?: string | null
}

withDefaults(defineProps<Props>(), {
  portal: null,
})

const provider = inject<any>('provider')

const dialog = ref<any>()
const callbackFn = ref<(() => void) | null>(null)

const open = ({ callback }: { callback?: () => void } = {}) => {
  callbackFn.value = callback ?? null

  dialog.value.open()
}

const confirm = async () => {
  const success = await provider.save()

  if (success) {
    if (callbackFn.value) {
      callbackFn.value()
    }

    return true
  }

  return false
}

defineExpose({ open })
</script>
